import de from "./de.json";
import en from "./en.json";
import es from "./es.json";
import fr from "./fr.json";
import it from "./it.json";
import ja from "./ja.json";
import ko from "./ko.json";
import nl from "./nl.json";
import pl from "./pl.json";
import ptBR from "./pt-BR.json";
import sv from "./sv.json";
import zhHans from "./zh-Hans.json";

/**
 * The message catalogs, one per supported language.
 *
 * Hand-authored source files, not generated - there is no translation API
 * behind them. `en.json` is the source of truth; `scripts/check-locales.mjs`
 * guards key parity and catches values left as their English source, and runs
 * from the build so a drifted catalog cannot deploy.
 *
 * Static imports, not a dynamic `import()`, so every catalog is bundled and
 * switching language needs no network round-trip.
 */
const CATALOGS = {
  en,
  de,
  fr,
  es,
  it,
  "pt-BR": ptBR,
  nl,
  pl,
  sv,
  "zh-Hans": zhHans,
  ja,
  ko,
};

/**
 * The catalog for a language, layered over English.
 *
 * The merge is what makes a missing key degrade to readable English rather
 * than to a raw key like `nav.product.label` - which matters because a new
 * English string can land before its translations do.
 */
export function catalogFor(language) {
  const target = CATALOGS[language];
  return target && target !== en ? { ...en, ...target } : en;
}

export default CATALOGS;
